export const sortByLocale = (locale: string) => (first: string, second: string) =>
  first.localeCompare(second, locale);

export const sortLanguageCodes = (
  language1: string,
  language2: string,
  t: (text: string) => string,
  locale: string
) => sortByLocale(locale)(t(`languages.${language1}`), t(`languages.${language2}`));

export const sortLanguages =
  (t: (text: string) => string, locale: string) => (l1: { code: string }, l2: { code: string }) =>
    sortLanguageCodes(l1.code, l2.code, t, locale);

export const sortCodes =
  (t: (text: string) => string, locale: string) => (code1: string, code2: string) =>
    sortLanguageCodes(code1, code2, t, locale);
